var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "settings__section" }, [
    _c("div", { staticClass: "settings__container" }, [
      _vm.modal.show
        ? _c("div", { staticClass: "h-vertical-align-container" }, [
            _c("div", {
              staticClass: "modal__close",
              on: {
                click: function($event) {
                  _vm.removeOverlay()
                }
              }
            }),
            _c("div", {
              staticClass: "modal__overlay",
              on: {
                click: function($event) {
                  _vm.removeOverlay()
                }
              }
            }),
            _c("div", { staticClass: "modal__wrapper" }, [
              _c("div", { staticClass: "modal__form modal__form--manageSub" }, [
                _c("h1", [_vm._v("Manage your subscription")]),
                _c(
                  "a",
                  {
                    staticClass: "btn btn--black",
                    attrs: { href: _vm.updateUrl }
                  },
                  [_vm._v("Update payment method")]
                ),
                _c(
                  "a",
                  {
                    staticClass: "btn btn--white",
                    attrs: { href: _vm.cancelUrl }
                  },
                  [_vm._v("Cancel subscription")]
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm.modalerror.show
        ? _c("div", { staticClass: "h-vertical-align-container" }, [
            _c("div", {
              staticClass: "modal__close",
              on: {
                click: function($event) {
                  _vm.removeOverlay()
                }
              }
            }),
            _c("div", {
              staticClass: "modal__overlay",
              attrs: { "n@click": "removeOverlay()" }
            }),
            _vm._m(0)
          ])
        : _vm._e(),
      _vm.message
        ? _c("div", { staticClass: "account__section--messages" }, [
            _vm.error
              ? _c("div", { staticClass: "message error" }, [
                  _c("p", [_vm._v(_vm._s(_vm.error))]),
                  _c("a", {
                    staticClass: "close",
                    on: {
                      click: function($event) {
                        _vm.error = false
                        _vm.message = false
                      }
                    }
                  })
                ])
              : _vm._e(),
            _vm.success
              ? _c("div", { staticClass: "message success" }, [
                  _c("p", [_vm._v("Changes saved successfully.")]),
                  _c("a", {
                    staticClass: "close",
                    on: {
                      click: function($event) {
                        _vm.success = false
                        _vm.message = false
                      }
                    }
                  })
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _c("div", { staticClass: "settings__flixelPlan" }, [
        _c(
          "div",
          { staticClass: "settings__flixelPlan--header" },
          [
            _c("div", { staticClass: "settings__flixelPlan--title" }, [
              _c("h1", [_vm._v(_vm._s(_vm.subscription.plan_display_name))]),
              !_vm.checkPlan("free")
                ? _c("h2", [
                    _vm._v(
                      "Subscription valid until " +
                        _vm._s(_vm._f("date")(_vm.subscription.expiry_date))
                    )
                  ])
                : _vm._e()
            ]),
            !_vm.checkPlan("free")
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn--purpleLight",
                    on: {
                      click: function($event) {
                        _vm.openManageSub()
                      }
                    }
                  },
                  [_vm._v("Manage Subscription")]
                )
              : _vm._e(),
            _vm.checkPlan("free") ? _c("get-plan") : _vm._e()
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "flixelPlan__content" },
        [
          !_vm.checkPlan("agency")
            ? _c("div", { staticClass: "flixelPlan__content--item" }, [
                _c("p", { staticClass: "meter__title" }, [_vm._v("Storage")]),
                _c("p", { staticClass: "meter__title" }, [
                  _vm._v(
                    _vm._s(_vm.convertToGb(_vm.subscription.storage_usage)) +
                      " of " +
                      _vm._s(_vm.convertToGb(_vm.subscription.storage_limit))
                  )
                ])
              ])
            : _vm._e(),
          !_vm.checkPlan("agency")
            ? _c("Meter", {
                staticClass: "flixelPlan__meter",
                attrs: {
                  val1: "subscription.storage_usage",
                  val2: "subscription.storage_limit"
                }
              })
            : _vm._e(),
          _vm.isOverLimit(
            _vm.subscription.storage_usage,
            _vm.subscription.storage_limit
          )
            ? _c("div", { staticClass: "warning" }, [
                _c("p", [
                  _vm._v(
                    "Storage usage exceeded! Consider upgrading to increase your limit."
                  )
                ])
              ])
            : _vm._e(),
          _vm.subscription.plan_includes_hosting
            ? _c("div", { staticClass: "flixelPlan__content--item" }, [
                _c("p", { staticClass: "meter__title" }, [
                  _vm._v("Embed Views")
                ]),
                _c("p", { staticClass: "meter__title" }, [
                  _vm._v(
                    _vm._s(_vm._f("number")(_vm.subscription.embed_count)) +
                      " of " +
                      _vm._s(
                        _vm._f("number")(_vm.subscription.embed_count_limit)
                      )
                  )
                ])
              ])
            : _vm._e(),
          _vm.subscription.plan_includes_hosting
            ? _c(
                "div",
                [
                  _c("Meter", {
                    attrs: {
                      val1: _vm.subscription.embed_count,
                      val2: _vm.subscription.embed_count_limit
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isOverLimit(
            _vm.subscription.embed_count,
            _vm.subscription.embed_count_limit
          )
            ? _c("div", { staticClass: "warning" }, [
                _c("p", [
                  _vm._v(
                    "Embed views exceeded! Consider upgrading to increase your limit."
                  )
                ])
              ])
            : _vm._e(),
          _vm.checkPlan("agency")
            ? _c("div", { staticClass: "flixelPlan__content-item" }, [
                _c("p", { staticClass: "meter__title" }, [
                  _vm._v("You have unlimited Flixel storage.")
                ])
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._m(1),
      _c("div", { staticClass: "publicDetails__section" }, [
        _c(
          "form",
          {
            attrs: { name: "updateUser" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                _vm.updateUserInvoke(_vm.updatedProfile, _vm.updatedAccount)
              }
            }
          },
          [
            _c("div", { staticClass: "settings__inputs" }, [
              _c("div", { staticClass: "ui-input" }, [
                _vm._m(2),
                _c("div", { staticClass: "ui-input--item" }, [
                  !_vm.newAvatar
                    ? _c(
                        "div",
                        {
                          staticClass: "avatar",
                          style: {
                            backgroundImage:
                              "url(" + _vm.user.profile.avatar + ")"
                          }
                        },
                        [
                          _c("p", [_vm._v("Update Profile Picture")]),
                          _c("div", { staticClass: "avatar__text" }),
                          _c("div", { staticClass: "hidden_fileupload" }, [
                            _c("input", {
                              attrs: {
                                type: "file",
                                "file-model": "newAvatar"
                              },
                              on: {
                                change: function($event) {
                                  _vm.processAvatar($event)
                                }
                              }
                            })
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm.newAvatar
                    ? _c(
                        "div",
                        {
                          staticClass: "avatar",
                          style: {
                            backgroundImage: "url(" + _vm.newAvatar + ")"
                          }
                        },
                        [
                          _c("p", [_vm._v("Update Profile Picture")]),
                          _c("div", { staticClass: "avatar__text" }),
                          _vm._m(3)
                        ]
                      )
                    : _vm._e()
                ])
              ]),
              _c("div", { staticClass: "ui-input ui-input--center" }, [
                _vm._m(4),
                _c("div", { staticClass: "ui-input--item" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.updatedProfile.realname,
                        expression: "updatedProfile.realname"
                      }
                    ],
                    attrs: {
                      type: "text",
                      placeholder: "Your name",
                      maxlength: "50"
                    },
                    domProps: { value: _vm.updatedProfile.realname },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.updatedProfile,
                          "realname",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ]),
              _c("div", { staticClass: "ui-input ui-input--center" }, [
                _vm._m(5),
                _c("div", { staticClass: "ui-input--item" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.updatedAccount.email,
                        expression: "updatedAccount.email"
                      }
                    ],
                    attrs: {
                      type: "text",
                      placeholder: "Your email",
                      maxlength: "35",
                      required: "required"
                    },
                    domProps: { value: _vm.updatedAccount.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.updatedAccount,
                          "email",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ]),
              _c("div", { staticClass: "ui-input ui-input--center" }, [
                _vm._m(6),
                _c("div", { staticClass: "ui-input--item" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.updatedProfile.url,
                        expression: "updatedProfile.url"
                      }
                    ],
                    attrs: { type: "text", placeholder: "Your website" },
                    domProps: { value: _vm.updatedProfile.url },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.updatedProfile, "url", $event.target.value)
                      }
                    }
                  })
                ])
              ]),
              _c("div", { staticClass: "ui-input" }, [
                _vm._m(7),
                _c("div", { staticClass: "ui-input--item" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.updatedProfile.description,
                        expression: "updatedProfile.description"
                      }
                    ],
                    attrs: {
                      maxlength: "140",
                      placeholder: "Something interesting about yourself ",
                      cols: "10",
                      rows: "5",
                      charswidth: "23"
                    },
                    domProps: { value: _vm.updatedProfile.description },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.updatedProfile,
                          "description",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ]),
              _vm._m(8)
            ])
          ]
        )
      ]),
      _vm._m(9),
      _c("div", { staticClass: "publicDetails__section" }, [
        _c(
          "form",
          {
            attrs: { name: "updateUser" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                _vm.updateUserInvoke(_vm.updatedProfile, _vm.updatedAccount)
              }
            }
          },
          [
            _c("div", { staticClass: "settings__inputs" }, [
              _c("div", { staticClass: "ui-input" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "ui-input--item marketingConsent--container ui-input--desktop"
                  },
                  [
                    _c("label", { staticClass: "checkbox--container" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.updatedProfile.marketing_consent,
                            expression: "updatedProfile.marketing_consent"
                          }
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(
                            _vm.updatedProfile.marketing_consent
                          )
                            ? _vm._i(
                                _vm.updatedProfile.marketing_consent,
                                null
                              ) > -1
                            : _vm.updatedProfile.marketing_consent
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.updatedProfile.marketing_consent,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.updatedProfile,
                                    "marketing_consent",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.updatedProfile,
                                    "marketing_consent",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.updatedProfile,
                                "marketing_consent",
                                $$c
                              )
                            }
                          }
                        }
                      }),
                      _c("span", { staticClass: "checkmark" })
                    ])
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "ui-input--item marketingConsent--container" },
                  [
                    _c(
                      "label",
                      { staticClass: "checkbox--container ui-input--mobile" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.updatedProfile.marketing_consent,
                              expression: "updatedProfile.marketing_consent"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(
                              _vm.updatedProfile.marketing_consent
                            )
                              ? _vm._i(
                                  _vm.updatedProfile.marketing_consent,
                                  null
                                ) > -1
                              : _vm.updatedProfile.marketing_consent
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.updatedProfile.marketing_consent,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.updatedProfile,
                                      "marketing_consent",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.updatedProfile,
                                      "marketing_consent",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(
                                  _vm.updatedProfile,
                                  "marketing_consent",
                                  $$c
                                )
                              }
                            }
                          }
                        }),
                        _c("span", { staticClass: "checkmark" })
                      ]
                    ),
                    _c("h4", [_vm._v("Marketing Consent")]),
                    _vm._m(10)
                  ]
                )
              ]),
              _c("div", { staticClass: "ui-input" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "ui-input--item marketingConsent--container ui-input--desktop"
                  },
                  [
                    _c("label", { staticClass: "checkbox--container" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.updatedProfile.tracking_consent,
                            expression: "updatedProfile.tracking_consent"
                          }
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(
                            _vm.updatedProfile.tracking_consent
                          )
                            ? _vm._i(
                                _vm.updatedProfile.tracking_consent,
                                null
                              ) > -1
                            : _vm.updatedProfile.tracking_consent
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.updatedProfile.tracking_consent,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.updatedProfile,
                                    "tracking_consent",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.updatedProfile,
                                    "tracking_consent",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.updatedProfile,
                                "tracking_consent",
                                $$c
                              )
                            }
                          }
                        }
                      }),
                      _c("span", { staticClass: "checkmark" })
                    ])
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "ui-input--item marketingConsent--container" },
                  [
                    _c(
                      "label",
                      { staticClass: "checkbox--container ui-input--mobile" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.updatedProfile.tracking_consent,
                              expression: "updatedProfile.tracking_consent"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(
                              _vm.updatedProfile.tracking_consent
                            )
                              ? _vm._i(
                                  _vm.updatedProfile.tracking_consent,
                                  null
                                ) > -1
                              : _vm.updatedProfile.tracking_consent
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.updatedProfile.tracking_consent,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.updatedProfile,
                                      "tracking_consent",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.updatedProfile,
                                      "tracking_consent",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(
                                  _vm.updatedProfile,
                                  "tracking_consent",
                                  $$c
                                )
                              }
                            }
                          }
                        }),
                        _c("span", { staticClass: "checkmark" })
                      ]
                    ),
                    _c("h4", [_vm._v("Analytics Consent")]),
                    _vm._m(11)
                  ]
                )
              ]),
              _vm._m(12)
            ])
          ]
        )
      ]),
      _c("a", { attrs: { id: "changePassword" } }),
      _vm._m(13),
      _c("div", { staticClass: "publicDetails__section" }, [
        _c(
          "form",
          {
            attrs: { name: "updatePassword" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                _vm.updateUserInvoke(_vm.updatedProfile, _vm.updatedAccount)
              }
            }
          },
          [
            _c("div", { staticClass: "settings__inputs" }, [
              _c("div", { staticClass: "ui-input ui-input--center" }, [
                _vm._m(14),
                _c("div", { staticClass: "ui-input--item" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.updatedAccount.password,
                        expression: "updatedAccount.password"
                      }
                    ],
                    attrs: {
                      type: "password",
                      name: "password",
                      placeholder: "Your new password",
                      required: "required"
                    },
                    domProps: { value: _vm.updatedAccount.password },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.updatedAccount,
                          "password",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ]),
              _c("div", { staticClass: "ui-input ui-input--center" }, [
                _vm._m(15),
                _c("div", { staticClass: "ui-input--item" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password_repeat,
                        expression: "password_repeat"
                      }
                    ],
                    attrs: {
                      type: "password",
                      placeholder: "Type it again",
                      required: "required"
                    },
                    domProps: { value: _vm.password_repeat },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.password_repeat = $event.target.value
                      }
                    }
                  })
                ])
              ]),
              _c("div", { staticClass: "ui-input" }, [
                _c("div", { staticClass: "ui-input--item" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn--purpleLight",
                      class: {
                        invalid:
                          _vm.updatedAccount.password !== _vm.password_repeat ||
                          !_vm.updatedAccount.password ||
                          _vm.updatedAccount.password.length < 6
                      }
                    },
                    [_vm._v("Save changes")]
                  )
                ])
              ])
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal__wrapper" }, [
      _c(
        "div",
        {
          staticClass:
            "modal__form modal__form--manageSub modal__form--manageSubError"
        },
        [
          _c("h1", [_vm._v("We've encountered an error.")]),
          _c("h2", [
            _vm._v("Please contact Flixel so that we can resolve this for you.")
          ]),
          _c(
            "a",
            {
              attrs: {
                href:
                  "mailto:support@flixel.com?subject=Manage%20Subscription%20Error"
              }
            },
            [
              _c("button", { staticClass: "btn btn--purpleLight" }, [
                _vm._v("Contact Support")
              ])
            ]
          ),
          _c("p", [_vm._v("support@flixel.com")])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "settingSection__title" }, [
      _c("h3", [_vm._v("Public Details")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui-input--item" }, [
      _c("label", [_vm._v("Photo")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hidden_fileupload" }, [
      _c("input", { attrs: { type: "file", "file-model": "newAvatar" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui-input--item" }, [
      _c("label", [_vm._v("Name")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui-input--item" }, [
      _c("label", [_vm._v("Email")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui-input--item" }, [
      _c("label", [_vm._v("Website")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui-input--item" }, [
      _c("label", [_vm._v("Bio")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui-input" }, [
      _c("div", { staticClass: "ui-input--item" }, [
        _c(
          "button",
          {
            staticClass:
              "btn btn--purpleLight { invalid: updateUser.$invalid }",
            attrs: { type: "submit" }
          },
          [_vm._v("Save changes")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "settingSection__title" }, [
      _c("h3", [_vm._v("Consent")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "subtext" }, [
      _c("p", [
        _vm._v("Flixel can send me product updates and offers via email")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "subtext" }, [
      _c("p", [_vm._v("Help Flixel improve our app by sharing app activity")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui-input" }, [
      _c("div", { staticClass: "ui-input--item" }, [
        _c(
          "button",
          {
            staticClass:
              "btn btn--purpleLight { invalid: updateUser.$invalid }",
            attrs: { type: "submit" }
          },
          [_vm._v("Save changes")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "settingSection__title" }, [
      _c("h3", [_vm._v("Change Your Password")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui-input--item" }, [
      _c("label", [_vm._v("New Password")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui-input--item" }, [
      _c("label", [_vm._v("Type it again")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53cc84dd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53cc84dd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Settings.vue
// module id = null
// module chunks = 